import { createSelector } from 'reselect'

export const getUserGroup = (state, props) => {
  return state.kanbo.userGroups[props.id]
}

export default () => createSelector(
  [
    getUserGroup
  ],
  (
    userGroup
  ) => ({
    userGroup
  })
)
